import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs, getBrandOptions } from "../../utils/constants";
import YearCalendar from "../../shared/YearlyCalendar";
import { useSelector } from "react-redux";
function MonthlyVsEenadu() {
  const [data, setData] = useState([{}]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  let totalPlanned = 0,
    totalAchieved = 0,
    totalNewspaperRevenue = 0;

  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/monthlyrevenue",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          type: selectedType,
          year: selectedYear,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const headers = [
        [
          "Date",
          "Revenue",
          "Achieved",
          "Achived %",
          `${selectedNewspaper} Revenue`,
          `% ${selectedNewspaper}`,
        ],
      ];
      let dates = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ]
      let total_planned = 0,
        total_achieved = 0,
        total_newspaper = 0;
      let rows = Array.from({ length: 12 }).map((_,index) => {
        const rowData =
          data?.data?.find((row) => row.month === index + 1) || {};
        const planned = rowData.revenue || 0;
        const achieved = rowData.Way2news || 0;
        const newspaperRevenue = rowData[selectedNewspaper] || 0;
        total_planned += planned;
        total_achieved += achieved;
        total_newspaper += newspaperRevenue;
        return [
          dates[index],
          planned,
          achieved,
          achieved ? ((achieved / planned) * 100).toFixed(2) + "%" : "-",
          newspaperRevenue,
          achieved
            ? ((achieved / newspaperRevenue) * 100).toFixed(2) + "%"
            : "-",
        ];
      });
      rows.push([
        'Total', 
        total_planned,
        total_achieved,
        total_achieved
          ? ((total_achieved / total_planned) * 100).toFixed(2) + "%"
          : "-",
        total_newspaper,
        total_achieved
          ? ((total_achieved / total_newspaper) * 100).toFixed(2) + "%"
          : "-",
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "monthly revenue");
      XLSX.writeFile(workbook, `MonthlyRevenue.xlsx`);
    } catch (error) {
      console.error(error, "monthly revenue");
    } finally {
      setDownloadLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType, selectedYear]);

  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Monthly Revenue</h5>
        <aside className="flex gap-3 items-center">
          <SlSelect
            size="small"
            value={selectedType}
            label="Team"
            onSlChange={(e) => {
              setSelectedType(e.target.value);
            }}
          >
            {data?.userType === -1 ? (
              <SlOption value="all">All</SlOption>
            ) : null}
            {getBrandOptions(
              data?.userType,
              localStorage.getItem("email")
            )?.map((type) => (
              <SlOption key={type.value} value={type.value}>
                {type.label}
              </SlOption>
            ))}
          </SlSelect>
          <YearCalendar startYear={2023} endYear={2100}></YearCalendar>

          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th>Date</th>
              <th>Target Revenue</th>
              <th>Target Achieved</th>
              <th>Achieved %</th>
              <th>{selectedNewspaper} Revenue</th>
              <th>% {selectedNewspaper}</th>
            </tr>
          </thead>
          {!loader && data?.data?.length > 0 ? (
            <tbody>
              {[
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sept",
                "Oct",
                "Nov",
                "Dec",
              ].map((month, index) => {
                const rowData =
                  data?.data?.find((row) => row.month === index + 1) || {};
                const planned = rowData.revenue || 0;
                const achieved = rowData.Way2news || 0;
                const newspaperRevenue = rowData[selectedNewspaper] || 0;

                // Accumulate Totals
                totalPlanned += planned;
                totalAchieved += achieved;
                totalNewspaperRevenue += newspaperRevenue;

                return (
                  <tr key={index}>
                    <td className="!bg-orange-100">{month}</td>
                    <td>{toLakhs(planned)}</td>
                    <td>{toLakhs(achieved)}</td>
                    <td>
                      {achieved
                        ? ((achieved / planned) * 100).toFixed(2) + "%"
                        : "-"}
                    </td>
                    <td>{toLakhs(newspaperRevenue)}</td>
                    <td>
                      {achieved
                        ? ((achieved / newspaperRevenue) * 100).toFixed(2) + "%"
                        : "-"}
                    </td>
                  </tr>
                );
              })}

              {/* Totals Row */}
              <tr className="bg-gray-300 font-bold">
                <td>Total</td>
                <td>{toLakhs(totalPlanned)}</td>
                <td>{toLakhs(totalAchieved)}</td>
                <td>
                  {totalAchieved
                    ? ((totalAchieved / totalPlanned) * 100).toFixed(2) + "%"
                    : "-"}
                </td>
                <td>{toLakhs(totalNewspaperRevenue)}</td>
                <td>
                  {totalAchieved
                    ? ((totalAchieved / totalNewspaperRevenue) * 100).toFixed(
                        2
                      ) + "%"
                    : "-"}
                </td>
              </tr>
            </tbody>
          ) : loader ? (
            <TableSkelton rowSpan={15} colspan={6} />
          ) : (
            <NoDataFound colspan={6} />
          )}
        </table>
        ;
      </ScrollContainer>
    </>
  );
}

export default MonthlyVsEenadu;
